import React from "react";
import { Reveal, Overline } from "./Motion";
import { REVIEWS } from "@/data/cafe";
import { Star } from "lucide-react";

export default function Reviews() {
  return (
    <section className="bg-[#2C2523] py-24 md:py-32" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Overline>Customer Reviews</Overline>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F2EB] mt-4 font-medium">
              Loved by <span className="italic text-[#1C7C54]">regulars</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-[#1C7C54] text-[#1C7C54]" />)}</div>
            <span className="font-body text-[#F5F2EB]/70 text-sm">4.9 / 5 · Google Reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={(i % 4) * 0.08}>
              <div className="bg-[#1A1514] border border-white/10 rounded-sm p-7 h-full flex flex-col" data-testid={`review-${i}`}>
                <div className="flex mb-4">{[...Array(5)].map((_, j) => <Star key={j} className="h-4 w-4 fill-[#1C7C54] text-[#1C7C54]" />)}</div>
                <p className="font-display italic text-xl text-[#F5F2EB] leading-snug flex-1">"{r.text}"</p>
                <div className="mt-6 pt-4 border-t border-white/10">
                  <p className="font-body text-[#F5F2EB] text-sm">{r.name}</p>
                  <p className="overline text-[#1C7C54] mt-1">{r.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
